// extracted by mini-css-extract-plugin
export var callCard = "_ou-0";
export var callMessageButton = "_ou-1";
export var helpIcon = "_ou-3";
export var helpIconContainer = "_ou-4";
export var verticalDivider = "_ou-2";